.spectrum--light .spectrum-Button.focus-ring {
    box-shadow: 0 0 0 1px rgb(20, 115, 230);
  }
.spectrum--light .spectrum-Button:active {
    box-shadow: none;
  }
.spectrum--light .spectrum-ClearButton {
  background-color: transparent;

  color: rgb(110, 110, 110);
}
.spectrum--light .spectrum-ClearButton:hover {
    background-color: transparent;

    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-ClearButton:active {
    background-color: transparent;

    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-ClearButton.focus-ring {
    background-color: transparent;

    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-ClearButton:disabled,
.spectrum--light .spectrum-ClearButton.is-disabled {
    background-color: transparent;

    color: rgb(202, 202, 202);
  }
.spectrum--light .spectrum-Button--cta {
  background-color: rgb(20, 115, 230);
  border-color: rgb(20, 115, 230);
  color: rgb(255, 255, 255);
}
.spectrum--light .spectrum-Button--cta:hover {
    background-color: rgb(13, 102, 208);
    border-color: rgb(13, 102, 208);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--cta.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--cta:active {
    background-color: rgb(13, 102, 208);
    border-color: rgb(13, 102, 208);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--cta:disabled,
.spectrum--light .spectrum-Button--cta.is-disabled {
    background-color: rgb(234, 234, 234);
    border-color: rgb(234, 234, 234);
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-Button--primary {
  background-color: transparent;
  border-color: rgb(75, 75, 75);
  color: rgb(75, 75, 75);
}
.spectrum--light .spectrum-Button--primary:hover {
    background-color: rgb(75, 75, 75);
    border-color: rgb(75, 75, 75);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--primary.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--primary:active {
    background-color: rgb(44, 44, 44);
    border-color: rgb(44, 44, 44);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--primary:disabled,
.spectrum--light .spectrum-Button--primary.is-disabled {
    background-color: rgb(234, 234, 234);
    border-color: rgb(234, 234, 234);
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-Button--secondary {
  background-color: transparent;
  border-color: rgb(110, 110, 110);
  color: rgb(110, 110, 110);
}
.spectrum--light .spectrum-Button--secondary:hover {
    background-color: rgb(110, 110, 110);
    border-color: rgb(110, 110, 110);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--secondary.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--secondary:active {
    background-color: rgb(75, 75, 75);
    border-color: rgb(75, 75, 75);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--secondary:disabled,
.spectrum--light .spectrum-Button--secondary.is-disabled {
    background-color: rgb(234, 234, 234);
    border-color: rgb(234, 234, 234);
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-Button--warning {
  background-color: transparent;
  border-color: rgb(201, 37, 45);
  color: rgb(201, 37, 45);
}
.spectrum--light .spectrum-Button--warning:hover {
    background-color: rgb(201, 37, 45);
    border-color: rgb(201, 37, 45);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--warning.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--warning:active {
    background-color: rgb(187, 18, 26);
    border-color: rgb(187, 18, 26);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--warning:disabled,
.spectrum--light .spectrum-Button--warning.is-disabled {
    background-color: rgb(234, 234, 234);
    border-color: rgb(234, 234, 234);
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-Button--overBackground {
  background-color: transparent;
  border-color: rgb(255, 255, 255);
  color: rgb(255, 255, 255);
}
.spectrum--light .spectrum-Button--overBackground:hover {
    background-color: rgb(255, 255, 255);
    border-color: rgb(255, 255, 255);
    color: inherit;
  }
.spectrum--light .spectrum-Button--overBackground.focus-ring {
    background-color: rgb(255, 255, 255);
    border-color: rgb(255, 255, 255);
    color: inherit;
    box-shadow: 0 0 0 1px rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--overBackground:active {
    background-color: rgb(255, 255, 255);
    border-color: rgb(255, 255, 255);
    color: inherit;
    box-shadow: none;
  }
.spectrum--light .spectrum-Button--overBackground:disabled,
.spectrum--light .spectrum-Button--overBackground.is-disabled {
    background-color: rgba(255,255,255,0.1);
    border-color: transparent;
    color: rgba(255,255,255,0.35);
  }
.spectrum--light .spectrum-Button--overBackground.spectrum-Button--quiet,
.spectrum--light .spectrum-ClearButton--overBackground {
  background-color: transparent;
  border-color: transparent;
  color: rgb(255, 255, 255);
}
.spectrum--light .spectrum-Button--overBackground.spectrum-Button--quiet:hover,
.spectrum--light .spectrum-ClearButton--overBackground:hover {
    background-color: rgba(255,255,255,0.1);
    border-color: transparent;
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--overBackground.spectrum-Button--quiet.focus-ring,
.spectrum--light .spectrum-ClearButton--overBackground.focus-ring {
    background-color: rgb(255, 255, 255);
    border-color: rgb(255, 255, 255);
    color: inherit;
    box-shadow: 0 0 0 1px rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--overBackground.spectrum-Button--quiet:active,
.spectrum--light .spectrum-ClearButton--overBackground:active {
    background-color: rgba(255,255,255,0.15);
    border-color: transparent;
    color: rgb(255, 255, 255);
    box-shadow: none;
  }
.spectrum--light .spectrum-Button--overBackground.spectrum-Button--quiet:disabled,
.spectrum--light .spectrum-Button--overBackground.spectrum-Button--quiet.is-disabled,
.spectrum--light .spectrum-ClearButton--overBackground:disabled,
.spectrum--light .spectrum-ClearButton--overBackground.is-disabled {
    background-color: transparent;
    border-color: transparent;
    color: rgba(255,255,255,0.15);
  }
.spectrum--light .spectrum-Button--primary.spectrum-Button--quiet {
  background-color: transparent;
  border-color: transparent;
  color: rgb(75, 75, 75);
}
.spectrum--light .spectrum-Button--primary.spectrum-Button--quiet:hover {
    background-color: rgb(234, 234, 234);
    border-color: rgb(234, 234, 234);
    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-Button--primary.spectrum-Button--quiet.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--primary.spectrum-Button--quiet:active {
    background-color: rgb(225, 225, 225);
    border-color: rgb(225, 225, 225);
    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-Button--primary.spectrum-Button--quiet:disabled,
.spectrum--light .spectrum-Button--primary.spectrum-Button--quiet.is-disabled {
    background-color: transparent;
    border-color: transparent;
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-Button--secondary.spectrum-Button--quiet {
  background-color: transparent;
  border-color: transparent;
  color: rgb(110, 110, 110);
}
.spectrum--light .spectrum-Button--secondary.spectrum-Button--quiet:hover {
    background-color: rgb(234, 234, 234);
    border-color: rgb(234, 234, 234);
    color: rgb(75, 75, 75);
  }
.spectrum--light .spectrum-Button--secondary.spectrum-Button--quiet.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--secondary.spectrum-Button--quiet:active {
    background-color: rgb(225, 225, 225);
    border-color: rgb(225, 225, 225);
    color: rgb(75, 75, 75);
  }
.spectrum--light .spectrum-Button--secondary.spectrum-Button--quiet:disabled,
.spectrum--light .spectrum-Button--secondary.spectrum-Button--quiet.is-disabled {
    background-color: transparent;
    border-color: transparent;
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-ActionButton,
.spectrum--light .spectrum-Tool {
  background-color: rgb(250, 250, 250);
  border-color: rgb(225, 225, 225);
  color: rgb(75, 75, 75);
}
.spectrum--light .spectrum-ActionButton .spectrum-Icon,
.spectrum--light .spectrum-Tool .spectrum-Icon {
    color: rgb(110, 110, 110);
  }
.spectrum--light .spectrum-ActionButton .spectrum-ActionButton-hold,
.spectrum--light .spectrum-Tool .spectrum-ActionButton-hold {
    color: rgb(110, 110, 110);
  }
.spectrum--light .spectrum-ActionButton:hover,
.spectrum--light .spectrum-Tool:hover {
    background-color: rgb(255, 255, 255);
    border-color: rgb(202, 202, 202);
    box-shadow: none;
    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-ActionButton:hover .spectrum-Icon,
.spectrum--light .spectrum-Tool:hover .spectrum-Icon {
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton:hover .spectrum-ActionButton-hold,
.spectrum--light .spectrum-Tool:hover .spectrum-ActionButton-hold {
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton.focus-ring,
.spectrum--light .spectrum-Tool.focus-ring {
    background-color: rgb(255, 255, 255);
    border-color: rgb(38, 128, 235);
    box-shadow: 0 0 0 1px rgb(38, 128, 235);
    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-ActionButton.focus-ring .spectrum-Icon,
.spectrum--light .spectrum-Tool.focus-ring .spectrum-Icon {
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton.focus-ring .spectrum-ActionButton-hold,
.spectrum--light .spectrum-Tool.focus-ring .spectrum-ActionButton-hold {
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton:active,
.spectrum--light .spectrum-Tool:active {
    background-color: rgb(234, 234, 234);
    border-color: rgb(202, 202, 202);
    box-shadow: none;
    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-ActionButton:active .spectrum-ActionButton-hold,
.spectrum--light .spectrum-Tool:active .spectrum-ActionButton-hold {
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton:disabled,
.spectrum--light .spectrum-ActionButton.is-disabled,
.spectrum--light .spectrum-Tool:disabled {
    background-color: rgb(234, 234, 234);
    border-color: rgb(234, 234, 234);
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-ActionButton:disabled .spectrum-Icon,
.spectrum--light .spectrum-ActionButton.is-disabled .spectrum-Icon,
.spectrum--light .spectrum-Tool:disabled .spectrum-Icon {
      color: rgb(202, 202, 202);
    }
.spectrum--light .spectrum-ActionButton:disabled .spectrum-ActionButton-hold,
.spectrum--light .spectrum-ActionButton.is-disabled .spectrum-ActionButton-hold,
.spectrum--light .spectrum-Tool:disabled .spectrum-ActionButton-hold {
      color: rgb(202, 202, 202);
    }
.spectrum--light .spectrum-ActionButton.is-selected {
    background-color: rgb(234, 234, 234);
    border-color: rgb(225, 225, 225);
    color: rgb(75, 75, 75);
  }
.spectrum--light .spectrum-ActionButton.is-selected .spectrum-Icon {
      color: rgb(110, 110, 110);
    }
.spectrum--light .spectrum-ActionButton.is-selected.focus-ring {
      background-color: rgb(234, 234, 234);
      border-color: rgb(38, 128, 235);
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton.is-selected.focus-ring .spectrum-Icon {
        color: rgb(44, 44, 44);
      }
.spectrum--light .spectrum-ActionButton.is-selected:hover {
      background-color: rgb(234, 234, 234);
      border-color: rgb(202, 202, 202);
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton.is-selected:hover .spectrum-Icon {
        color: rgb(44, 44, 44);
      }
.spectrum--light .spectrum-ActionButton.is-selected:active {
      background-color: rgb(234, 234, 234);
      border-color: rgb(202, 202, 202);
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton.is-selected:active .spectrum-Icon {
        color: rgb(44, 44, 44);
      }
.spectrum--light .spectrum-ActionButton.is-selected:disabled,
.spectrum--light .spectrum-ActionButton.is-selected.is-disabled {
      background-color: rgb(234, 234, 234);
      border-color: rgb(234, 234, 234);
      color: rgb(179, 179, 179);
    }
.spectrum--light .spectrum-ActionButton.is-selected:disabled .spectrum-Icon,
.spectrum--light .spectrum-ActionButton.is-selected.is-disabled .spectrum-Icon {
        color: rgb(202, 202, 202);
      }
.spectrum--light .spectrum-ActionButton--quiet,
.spectrum--light .spectrum-Tool {
  background-color: transparent;
  border-color: transparent;
  color: rgb(75, 75, 75);
}
.spectrum--light .spectrum-ActionButton--quiet:hover,
.spectrum--light .spectrum-Tool:hover {
    background-color: transparent;
    border-color: transparent;
    color: rgb(44, 44, 44);
    box-shadow: none;
  }
.spectrum--light .spectrum-ActionButton--quiet.focus-ring,
.spectrum--light .spectrum-Tool.focus-ring {
    background-color: transparent;
    box-shadow: 0 0 0 1px rgb(38, 128, 235);
    border-color: rgb(38, 128, 235);
    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-ActionButton--quiet:active,
.spectrum--light .spectrum-Tool:active {
    background-color: rgb(225, 225, 225);
    border-color: rgb(225, 225, 225);
    color: rgb(44, 44, 44);
    box-shadow: none;
  }
.spectrum--light .spectrum-ActionButton--quiet:disabled,
.spectrum--light .spectrum-ActionButton--quiet.is-disabled,
.spectrum--light .spectrum-Tool:disabled {
    background-color: transparent;
    border-color: transparent;
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-ActionButton--quiet.is-selected {
    background-color: rgb(225, 225, 225);
    border-color: rgb(225, 225, 225);
    color: rgb(75, 75, 75);
  }
.spectrum--light .spectrum-ActionButton--quiet.is-selected.focus-ring {
      background-color: rgb(225, 225, 225);
      border-color: rgb(38, 128, 235);
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton--quiet.is-selected:hover {
      background-color: rgb(225, 225, 225);
      border-color: rgb(225, 225, 225);
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton--quiet.is-selected:active {
      background-color: rgb(225, 225, 225);
      border-color: rgb(225, 225, 225);
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-ActionButton--quiet.is-selected:disabled,
.spectrum--light .spectrum-ActionButton--quiet.is-selected.is-disabled {
      background-color: rgb(234, 234, 234);
      border-color: rgb(234, 234, 234);
      color: rgb(179, 179, 179);
    }
.spectrum--light .spectrum-Button--warning.spectrum-Button--quiet {
  background-color: transparent;
  border-color: transparent;
  color: rgb(201, 37, 45);
}
.spectrum--light .spectrum-Button--warning.spectrum-Button--quiet:hover {
    background-color: rgb(234, 234, 234);
    border-color: rgb(234, 234, 234);
    color: rgb(187, 18, 26);
  }
.spectrum--light .spectrum-Button--warning.spectrum-Button--quiet.focus-ring {
    background-color: rgb(20, 115, 230);
    border-color: rgb(20, 115, 230);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-Button--warning.spectrum-Button--quiet:active {
    background-color: rgb(225, 225, 225);
    border-color: rgb(225, 225, 225);
    color: rgb(187, 18, 26);
  }
.spectrum--light .spectrum-Button--warning.spectrum-Button--quiet:disabled,
.spectrum--light .spectrum-Button--warning.spectrum-Button--quiet.is-disabled {
    background-color: transparent;
    border-color: transparent;
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-LogicButton--and {
  background-color: rgb(20, 115, 230);
  border-color: rgb(20, 115, 230);
  color: rgb(255, 255, 255);
}
.spectrum--light .spectrum-LogicButton--and:hover {
    background-color: rgb(9, 90, 186);
    border-color: rgb(9, 90, 186);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-LogicButton--and.focus-ring {
    background-color: rgb(9, 90, 186);
    border-color: rgb(38, 128, 235);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-LogicButton--and:disabled,
.spectrum--light .spectrum-LogicButton--and.is-disabled {
    background-color: rgb(234, 234, 234);
    border-color: rgb(234, 234, 234);
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-LogicButton--or {
  background-color: rgb(206, 39, 131);
  border-color: rgb(206, 39, 131);
  color: rgb(255, 255, 255);
}
.spectrum--light .spectrum-LogicButton--or:hover {
    background-color: rgb(174, 14, 102);
    border-color: rgb(174, 14, 102);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-LogicButton--or.focus-ring {
    background-color: rgb(174, 14, 102);
    border-color: rgb(38, 128, 235);
    color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-LogicButton--or:disabled,
.spectrum--light .spectrum-LogicButton--or.is-disabled {
    background-color: rgb(234, 234, 234);
    border-color: rgb(234, 234, 234);
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-FieldButton {
  color: rgb(75, 75, 75);
  background-color: rgb(250, 250, 250);
  border-color: rgb(225, 225, 225);
}
.spectrum--light .spectrum-FieldButton:hover {
    color: rgb(44, 44, 44);
    background-color: rgb(255, 255, 255);
    border-color: rgb(202, 202, 202);
  }
.spectrum--light .spectrum-FieldButton.focus-ring,
.spectrum--light .spectrum-FieldButton.is-focused {
    background-color: rgb(255, 255, 255);
    border-color: rgb(38, 128, 235);
    box-shadow: 0 0 0 1px rgb(38, 128, 235);
    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-FieldButton.focus-ring.is-placeholder,
.spectrum--light .spectrum-FieldButton.is-focused.is-placeholder {
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-FieldButton:active,
.spectrum--light .spectrum-FieldButton.is-selected {
    background-color: rgb(234, 234, 234);
    border-color: rgb(202, 202, 202);
  }
.spectrum--light .spectrum-FieldButton:active.focus-ring,
.spectrum--light .spectrum-FieldButton:active.is-focused,
.spectrum--light .spectrum-FieldButton.is-selected.focus-ring,
.spectrum--light .spectrum-FieldButton.is-selected.is-focused {
      box-shadow: none;
    }
.spectrum--light .spectrum-FieldButton.is-invalid {
    border-color: rgb(215, 55, 63);
  }
.spectrum--light .spectrum-FieldButton.is-invalid:hover {
      border-color: rgb(201, 37, 45);
    }
.spectrum--light .spectrum-FieldButton.is-invalid:active,
.spectrum--light .spectrum-FieldButton.is-invalid.is-selected {
      border-color: rgb(201, 37, 45);
    }
.spectrum--light .spectrum-FieldButton.is-invalid.focus-ring,
.spectrum--light .spectrum-FieldButton.is-invalid.is-focused {
      border-color: rgb(38, 128, 235);
      box-shadow: 0 0 0 1px rgb(38, 128, 235);
    }
.spectrum--light .spectrum-FieldButton:disabled,
.spectrum--light .spectrum-FieldButton.is-disabled {
    background-color: rgb(234, 234, 234);
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-FieldButton:disabled.focus-ring,
.spectrum--light .spectrum-FieldButton.is-disabled.focus-ring {
      box-shadow: none;
    }
.spectrum--light .spectrum-FieldButton:disabled .spectrum-Icon,
.spectrum--light .spectrum-FieldButton.is-disabled .spectrum-Icon {
      color: rgb(202, 202, 202);
    }
.spectrum--light .spectrum-FieldButton--quiet {
  color: rgb(75, 75, 75);
  border-color: transparent;
  background-color: transparent;
}
.spectrum--light .spectrum-FieldButton--quiet:hover {
    background-color: transparent;
    color: rgb(44, 44, 44);
  }
.spectrum--light .spectrum-FieldButton--quiet.focus-ring,
.spectrum--light .spectrum-FieldButton--quiet.is-focused {
    background-color: transparent;
    box-shadow: 0 2px 0 0 rgb(38, 128, 235);
  }
.spectrum--light .spectrum-FieldButton--quiet.focus-ring.is-placeholder,
.spectrum--light .spectrum-FieldButton--quiet.is-focused.is-placeholder {
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-FieldButton--quiet:active,
.spectrum--light .spectrum-FieldButton--quiet.is-selected {
    background-color: transparent;
    border-color: transparent;
  }
.spectrum--light .spectrum-FieldButton--quiet:active.focus-ring,
.spectrum--light .spectrum-FieldButton--quiet:active.is-focused,
.spectrum--light .spectrum-FieldButton--quiet.is-selected.focus-ring,
.spectrum--light .spectrum-FieldButton--quiet.is-selected.is-focused {
      background-color: transparent;
      box-shadow: 0 2px 0 0 rgb(38, 128, 235);
    }
.spectrum--light .spectrum-FieldButton--quiet.is-invalid.focus-ring,
.spectrum--light .spectrum-FieldButton--quiet.is-invalid.is-focused {
      box-shadow: 0 2px 0 0 rgb(38, 128, 235);
    }
.spectrum--light .spectrum-FieldButton--quiet:disabled,
.spectrum--light .spectrum-FieldButton--quiet.is-disabled {
    background-color: transparent;
    color: rgb(179, 179, 179);
  }
.spectrum--light .spectrum-FieldButton--quiet:disabled.focus-ring,
.spectrum--light .spectrum-FieldButton--quiet.is-disabled.focus-ring {
      box-shadow: none;
    }
.spectrum--light .spectrum-Tool.is-selected .spectrum-Icon {
      color: rgb(20, 115, 230);
    }
.spectrum--light .spectrum-Tool.is-selected .spectrum-Tool-hold {
      color: rgb(20, 115, 230);
    }
.spectrum--light .spectrum-Tool.is-selected:hover .spectrum-Icon {
        color: rgb(13, 102, 208);
      }
.spectrum--light .spectrum-Tool.is-selected:hover .spectrum-Tool-hold {
        color: rgb(13, 102, 208);
      }
.spectrum--light .spectrum-Tool.is-selected:active .spectrum-Icon {
        color: rgb(9, 90, 186);
      }
.spectrum--light .spectrum-Tool.is-selected:active .spectrum-Tool-hold {
        color: rgb(9, 90, 186);
      }
.spectrum--light .spectrum-Tool.is-selected.focus-ring .spectrum-Icon {
        color: rgb(13, 102, 208);
      }
.spectrum--light .spectrum-Tool.is-selected.focus-ring .spectrum-Tool-hold {
        color: rgb(13, 102, 208);
      }
.spectrum--light .spectrum-Tool.is-selected:disabled,
.spectrum--light .spectrum-Tool.is-selected.is-disabled {
      background-color: transparent;
      border-color: transparent;
    }
.spectrum--light .spectrum-Tool.is-selected:disabled .spectrum-Icon,
.spectrum--light .spectrum-Tool.is-selected.is-disabled .spectrum-Icon {
        color: rgb(202, 202, 202);
      }
.spectrum--light .spectrum-Tool.is-selected:disabled .spectrum-Tool-hold,
.spectrum--light .spectrum-Tool.is-selected.is-disabled .spectrum-Tool-hold {
        color: rgb(202, 202, 202);
      }
.spectrum--light .spectrum-Tool .spectrum-Tool-hold {
    color: rgb(110, 110, 110);
  }
.spectrum--light .spectrum-Tool:hover .spectrum-Tool-hold {
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-Tool:active {
    background-color: transparent;
    border-color: transparent;
  }
.spectrum--light .spectrum-Tool:active .spectrum-Tool-hold {
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-Tool.focus-ring .spectrum-Tool-hold {
      color: rgb(44, 44, 44);
    }
.spectrum--light .spectrum-Tool.is-disabled .spectrum-Tool-hold,
.spectrum--light .spectrum-Tool:disabled .spectrum-Tool-hold {
      color: rgb(202, 202, 202);
    }
